import { Card, Col, Row } from 'antd'
import React, { useState } from 'react'
import CarRegCustomSelectBox from '../../../../components/BookingFormComponents/CarRegCustomSelectBox'
import './style.css'
import * as Yup from 'yup'
import DynamicForm from '../../../../components/FormElements/DynamicForm';
import carPlaceholder from '../../../../assets/images/car.png'
import Button from '../../../../components/FormElements/Button';
import useMyGarageApi from '../../../../config/hooks/api/mygarage/useMyGarageApi';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../../store/common/generalSlice';

const AddCar = ({ refreshFeed }) => {
  const [selectedRegCarData, setSelectedRegCarData] = useState(null);
  const [reset, setReset] = useState(false)

  const { addVehicles } = useMyGarageApi();
  const dispatch = useDispatch()

  const myCar = (data) => {
    data && setSelectedRegCarData(data);
  }

  const form = {
    name: 'verifyCarForm',
    formFields: [
      {
        name: 'carRegNo',
        type: 'custom',
        label: '',
        width: { md: 24, sm: 24, xs: 24 },
        component: (
          <CarRegCustomSelectBox 
            reset={reset} 
            useApi={'verifyVehicle'} 
            myCar={(data) => myCar(data)} 
          />
        ),
        classes: '',
        icon: null,
      },
    ],
    formValidation: {
      // for services we are handling custom error because over there we are opening a modal to select sub services.
      carRegNo: Yup.string()
        .test('is-required', 'Vehicle Registration Number is required', function (value) {
          return !!value; // Ensure the value exists (non-empty)
        })
        .test(
          'conditional-validation',
          'Vehicle registration number must be 2 capital alphabets followed by 2 numbers followed by 3 capital alphabets.',
          function (value) {
            if (!value) {
              return true; // Skip length and pattern validation if the field is empty
            }
            if (value.startsWith('aaa') || value.startsWith('AAA')) {
              return true; // No pattern or length validation if it starts with 'aaa' or 'AAA'
            }
            const ukCarRegPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/i; // Case-insensitive pattern for UK car registration
            return value.length === 7 && ukCarRegPattern.test(value); // Validate length and pattern
          }
        ),
    }
  }

  const handleAddCar = async () => {
    try {
      if (selectedRegCarData) {
        let payload = selectedRegCarData
        payload.isApproved = true
        payload?.createdAt && delete payload.createdAt
        payload?.id && delete payload.id
        payload?.userId && delete payload.userId
        payload?.updatedAt && delete payload.updatedAt
        payload.isApproved = true
        
        try {
          setReset(false)

          const res = await addVehicles(payload);
          if (res?.status == 200) {
            dispatch(setMessage(res?.data?.message))
            refreshFeed()
          }
          else{
            setReset(true)
          }
        } catch (error) {
          console.log(error)
        }
        finally {
          setSelectedRegCarData(null)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }


  const handleSubmit = (values) => {
    if (values) {
      return
    }
  }



  return (
    <React.Fragment>
      <Col md={24} sm={24} xs={24}>
        <h5 className='heading-5 text-slate-600 font-semibold mb-4'>Add New Car</h5>
      </Col>
      <Col
        md={24}
        sm={24}
        xs={24}
      >
        <Row justify={'space-between'}>
          <Col
            lg={6}
            md={8}
            xs={24}
          >
            <p className='text-xs text-slate-400 mb-2'>Vehicle Registration:</p>
            <DynamicForm form={form} onSubmit={handleSubmit} id='verifyCarForm' />
          </Col>
          {selectedRegCarData && (
            <Col lg={8} md={12} sm={24} xs={24} className='flex items-start'>
              <Card bordered={false} className="card-main w-full">
                <Card bordered={false} className='bg-gray-100 card-gray'>
                  <Card bordered={false} className='mb-3'>
                    <img src={carPlaceholder} alt='car' className='img-fluid' />
                    <hr className='border-dashed border-1 border-gray-200 mb-4' />
                    <div className='model flex flex-col'>
                      <h4 className='heading-4 font-bold mb-1 registration'>
                        {selectedRegCarData?.vehicleRegistrationNumber ? selectedRegCarData?.vehicleRegistrationNumber : '-'}
                      </h4>
                      <h6 className='heading-6 font-bold text-sm'>
                        {selectedRegCarData?.make ? selectedRegCarData?.make : '-'}
                      </h6>
                    </div>
                    <hr className='border-dashed border-1 border-gray-200 mb-4' />
                    <Row>
                      <Col md={8} sm={8} xs={24}>
                        <div
                          className='text-center md:border-r sm:border-r border-r-0 md:border-b-0 sm:border-b-0 border-b 
                              px-1'
                        >
                          <h6 className='heading-6 font-bold mb-0'>{selectedRegCarData?.year ? selectedRegCarData?.year : '-'}</h6>
                          <small className='text-xs text-slate-500 inline-block font-medium md:mb-0 sm:mb-0 mb-2'>Year</small>
                        </div>
                      </Col>
                      <Col md={8} sm={8} xs={24}>
                        <div
                          className='text-center md:border-r sm:border-r border-r-0 md:border-b-0 sm:border-b-0 border-b 
                              px-1 md:my-0 sm:my-0 my-2'
                        >
                          <h6 className='heading-6 font-bold mb-0'>{selectedRegCarData?.engineSize ? selectedRegCarData?.engineSize : '-'}</h6>
                          <small className='text-xs text-slate-500 inline-block font-medium md:mb-0 sm:mb-0 mb-2'>Engine Size</small>
                        </div>
                      </Col>
                      <Col md={8} sm={8} xs={24}>
                        <div className='text-center px-1'>
                          <h6 className='heading-6 font-bold mb-0'>{selectedRegCarData?.fuelType ? selectedRegCarData?.fuelType : '-'}</h6>
                          <small className='text-xs text-slate-500 font-medium'>Fuel Type</small>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                  <div>
                    <Button.Basic
                      onClick={handleAddCar}
                      disabled={false}
                      icon={null}
                      loading={false}
                      type="primary"
                      size='medium'
                      text='Submit'
                      className='btn-primary w-full'
                    />
                  </div>
                </Card>
              </Card>
            </Col>
          )}
        </Row>
      </Col>
    </React.Fragment>
  )
}

export default AddCar
